import { OvlAddScreen } from "../../../_ovlclient/src/global/globals"
import { ScreenSYSEPT } from "./screens/ept"

export const SYSEPT_Init = () => {
  OvlAddScreen(ScreenSYSEPT, "SYSEPT")
}
